import __isEmpty from 'lodash/isEmpty';
import styles from './joc.module.scss';
import clsx from 'clsx';
import Enllac from 'components/corporatiu/Enllac';
import Boto from 'components/corporatiu/Boto';
import Icona from 'components/corporatiu/Icona';
import Imatge from 'components/corporatiu/Imatge';
import Player from 'components/corporatiu/Player';
import { useModal } from '../../../../../hooks/corporatiu/useModal';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Pagination } from 'swiper/modules';

function ModalMedia({ items, currentIndex, titol, onNavigate, onClickClose }) {
    const closeButtonRef = useRef(null);
    const item = items[currentIndex];
    const hasPrev = currentIndex > 0;
    const hasNext = currentIndex < items.length - 1;

    useEffect(() => {
        closeButtonRef.current?.focus();
    }, [currentIndex]);

    return (
        <div className={styles.modalScreenshotMask}>
            <button
                className={styles.modalScreenshotClose}
                type='button'
                onClick={onClickClose}
                ref={closeButtonRef}
                aria-label={item.type === 'video' ? 'Tanca el vídeo' : 'Tanca la imatge'}
            >
                <Icona icona='tanca' isBlanc={true} alt='Tanca' />
            </button>
            {hasPrev && (
                <button
                    type='button'
                    className={clsx(styles.modalNav, styles.modalNavPrev)}
                    onClick={() => onNavigate(currentIndex - 1)}
                    aria-label='Anterior'
                >
                    <Icona icona='fletxa_simple_esquerra' alt='Anterior' mida={24} inline={true} />
                </button>
            )}
            {hasNext && (
                <button
                    type='button'
                    className={clsx(styles.modalNav, styles.modalNavNext)}
                    onClick={() => onNavigate(currentIndex + 1)}
                    aria-label='Següent'
                >
                    <Icona icona='fletxa_simple_dreta' alt='Següent' mida={24} inline={true} />
                </button>
            )}
            <div className={styles.modalScreenshotContent}>
                {item.type === 'video' ? (
                    <div className={styles.modalScreenshotVideoWrapper}>
                        <Player id={item.id} />
                    </div>
                ) : (
                    <div className={styles.modalScreenshotImageWrapper}>
                        <Imatge src={item.src} alt={`Captura de pantalla de ${titol}`} layout='fill' objectFit='contain' />
                    </div>
                )}
            </div>
        </div>
    );
}

export default function Joc({ titol, background, logo, tags, entradeta, plataformes, demo, mesinfo, video, screenshots }) {
    const { setModal } = useModal();
    const [openPopupPlataforma, setOpenPopupPlataforma] = useState(false);

    const mediaItems = [];
    if (!__isEmpty(video?.id)) {
        mediaItems.push({ type: 'video', id: video.id });
    }
    if (!__isEmpty(screenshots?.imatges)) {
        screenshots.imatges.forEach((src) => mediaItems.push({ type: 'screenshot', src }));
    }
    const popupJugaRef = useRef(null);
    const tancaPlataformaRef = useRef(null);
    const openerElementRef = useRef(null);
    const stylesPopupJuga = clsx(styles.popupJuga, {
        [styles.open]: openPopupPlataforma
    });
    const stylesScreenshots = clsx(styles.screenshots, {
        [styles.screenshots]: true,
        [styles.rounded]: screenshots?.rounded === true
    });
    const navigationPrev = useRef(null);
    const navigationNext = useRef(null);

    const logoCrop = logo.url.replace('.png', '_' + logo.width + '.png');
    98;
    const screenshotCrop = screenshots?.height ? (screenshots.crop / screenshots.height) * 100 : 0;

    useEffect(() => {
        if (openPopupPlataforma) {
            tancaPlataformaRef.current?.focus();
            return;
        }

        openerElementRef.current?.focus();
        openerElementRef.current = null;
    }, [openPopupPlataforma]);

    const obrePopupPlataforma = (event) => {
        openerElementRef.current = event.currentTarget;
        setOpenPopupPlataforma(true);
    };

    const tancaPopupPlataforma = () => {
        setOpenPopupPlataforma(false);
    };

    const handlePopupKeyDown = (event) => {
        if (!openPopupPlataforma || event.key !== 'Tab') {
            return;
        }

        const focusableSelector =
            "button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";
        const focusableElements = popupJugaRef.current
            ? Array.from(popupJugaRef.current.querySelectorAll(focusableSelector))
            : [];

        if (__isEmpty(focusableElements)) {
            event.preventDefault();
            return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const activeElement = document.activeElement;

        if (event.shiftKey && activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
            return;
        }

        if (!event.shiftKey && activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    };

    const obreModal = (index) => {
        setModal(<ModalMedia items={mediaItems} currentIndex={index} titol={titol} onNavigate={obreModal} />, {
            mode: 'full-screen',
            closeOnClickOutside: true,
            className: styles.modalScreenshot
        });
    };

    return (
        <div className={styles.joc}>
            <div
                className={styles.informacio}
                style={{
                    backgroundImage: `url(${background})`
                }}
            >
                <div className={styles.infoWrapper}>
                    <h2 className={styles.titol}>
                        <Imatge src={logoCrop} alt={titol} width={logo.width} height={logo.height} />
                    </h2>
                    <div className={styles.tags}>
                        {tags.map((tag, index) => (
                            <span key={index}>{tag.tag}</span>
                        ))}
                    </div>
                    <div>{entradeta}</div>
                    <div className={styles.plataformes}>
                        {plataformes.Steam !== false && (
                            <div className={styles.plataforma}>
                                <Imatge src='/_resources/logos/steam.svg' width='688' height='264' alt='Disponible a Steam' />
                            </div>
                        )}

                        {plataformes.PS4 !== false && (
                            <div className={styles.plataforma}>
                                <Imatge
                                    src='/_resources/logos/ps4.svg'
                                    width='688'
                                    height='264'
                                    alt='Disponible a PlayStation4'
                                />
                            </div>
                        )}

                        {plataformes.PS5 !== false && (
                            <div className={styles.plataforma}>
                                <Imatge
                                    src='/_resources/logos/ps5.svg'
                                    width='688'
                                    height='264'
                                    alt='Disponible a PlayStation5'
                                />
                            </div>
                        )}

                        {plataformes.Xbox !== false && (
                            <div className={styles.plataforma}>
                                <Imatge src='/_resources/logos/xbox.svg' width='688' height='264' alt='Disponible a XBox' />
                            </div>
                        )}
                        {plataformes.Switch !== false && (
                            <div className={styles.plataforma}>
                                <Imatge
                                    src='/_resources/logos/switch.svg'
                                    width='688'
                                    height='264'
                                    alt='Disponible a Nintendo Switch'
                                />
                            </div>
                        )}
                        {plataformes.GooglePlay !== false && (
                            <div className={styles.plataforma}>
                                <Imatge
                                    src='/_resources/logos/googleplay.svg'
                                    width='688'
                                    height='264'
                                    alt='Disponible a Google Play'
                                />
                            </div>
                        )}
                        {plataformes.AppStore !== false && (
                            <div className={styles.plataforma}>
                                <Imatge
                                    src='/_resources/logos/applestore.svg'
                                    width='688'
                                    height='264'
                                    alt='Disponible a Apple App Store'
                                />
                            </div>
                        )}
                    </div>
                    <div className={styles.botons}>
                        {plataformes.Web === false && (
                            <Boto tag='button' text='Juga-hi' tema='ple3cat' fons='dark' onClick={obrePopupPlataforma} />
                        )}
                        {plataformes.Web !== false && (
                            <Boto tag='a' text='Juga-hi' tema='ple3cat' fons='dark' link={plataformes.Web} />
                        )}
                        {!__isEmpty(demo) && (
                            <Boto text='Demo gratuïta' tema='tresCatCTA' fons='dark' link={demo} novaFinestra={true} />
                        )}
                        {!__isEmpty(mesinfo) && <Boto text='Més informació' tema='linedBlanc' fons='dark' link={mesinfo} />}
                    </div>
                </div>
            </div>
            <Swiper
                spaceBetween={32}
                slidesPerView={3.8}
                slidesPerGroup={3}
                breakpoints={{
                    0: {
                        slidesPerView: 1.2,
                        slidesPerGroup: 1,
                        spaceBetween: 32
                    },
                    600: {
                        slidesPerView: 1.6,
                        slidesPerGroup: 1,
                        spaceBetween: 32
                    },
                    830: {
                        slidesPerView: 2.8,
                        slidesPerGroup: 2,
                        spaceBetween: 32
                    },
                    1304: {
                        slidesPerView: 3.8,
                        slidesPerGroup: 3,
                        spaceBetween: 32
                    }
                }}
                modules={[Navigation, FreeMode, Pagination]}
                navigation={{
                    prevEl: navigationPrev.current,
                    nextEl: navigationNext.current
                }}
                freeMode={true}
                pagination={{ clickable: true }}
                tag='div'
                wrapperTag='ul'
                updateOnWindowResize={true}
                keyboard={{
                    enabled: true
                }}
                className={stylesScreenshots}
            >
                {!__isEmpty(video?.id) && (
                    <SwiperSlide key={video.id + ' ' + titol} tag='li'>
                        <button type='button' className={styles.botoScreenshot} onClick={() => obreModal(0)}>
                            <Imatge
                                src={video.keyframe.replace('.jpg', '_469.jpg')}
                                alt={`Vídeo de ${titol}`}
                                width={427}
                                height={240}
                            />
                            <div className={styles.icoPlay}>
                                <Icona icona='play' isBlanc={true} className={styles.iconaPlay} />
                            </div>
                        </button>
                    </SwiperSlide>
                )}
                {!__isEmpty(screenshots?.imatges) &&
                    screenshots.imatges.map((screenshot, index) => (
                        <SwiperSlide key={index + ' ' + titol} tag='li'>
                            <button
                                type='button'
                                className={styles.botoScreenshot}
                                style={screenshotCrop > 0 ? { marginBottom: `${-screenshotCrop}%` } : undefined}
                                onClick={() => obreModal(!__isEmpty(video?.id) ? index + 1 : index)}
                            >
                                <Imatge
                                    src={screenshot.replace('.jpg', '_469.jpg')}
                                    alt={`Captura de pantalla de ${titol}`}
                                    width={screenshots.width}
                                    height={screenshots.height}
                                />
                            </button>
                        </SwiperSlide>
                    ))}
                <div className={styles.fletxes}>
                    <button ref={navigationPrev} className={styles.anterior}>
                        <Icona icona='fletxa_simple_esquerra' alt='Anterior' mida={24} inline={true} />
                    </button>
                    <button ref={navigationNext} className={styles.seguent}>
                        <Icona icona='fletxa_simple_dreta' alt='Següent' mida={24} inline={true} />
                    </button>
                </div>
            </Swiper>
            <div
                className={stylesPopupJuga}
                ref={popupJugaRef}
                role='dialog'
                aria-modal='true'
                aria-label='Tria plataforma'
                onKeyDown={handlePopupKeyDown}
            >
                <button className={styles.tancaPlataforma} type='button' onClick={tancaPopupPlataforma} ref={tancaPlataformaRef}>
                    <Icona icona='tanca' isBlanc={true} alt='Tanca' />
                </button>
                <div className={styles.botonsPlataforma}>
                    <p>Tria plataforma:</p>
                    {plataformes.Steam !== false && (
                        <Enllac href={plataformes.Steam} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/steam.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a Steam`}
                                />
                            </span>
                        </Enllac>
                    )}
                    {plataformes.PS4 !== false && (
                        <Enllac href={plataformes.PS4} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/ps4.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a PlayStation4`}
                                />
                            </span>
                        </Enllac>
                    )}
                    {plataformes.PS5 !== false && (
                        <Enllac href={plataformes.PS5} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/ps5.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a PlayStation5`}
                                />
                            </span>
                        </Enllac>
                    )}
                    {plataformes.Xbox !== false && (
                        <Enllac href={plataformes.Xbox} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/xbox.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a XBox`}
                                />
                            </span>
                        </Enllac>
                    )}
                    {plataformes.Switch !== false && (
                        <Enllac href={plataformes.Switch} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/switch.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a Switch`}
                                />
                            </span>
                        </Enllac>
                    )}
                    {plataformes.GooglePlay !== false && (
                        <Enllac href={plataformes.GooglePlay} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/googleplay.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a Google Play`}
                                />
                            </span>
                        </Enllac>
                    )}
                    {plataformes.AppStore !== false && (
                        <Enllac href={plataformes.AppStore} novaFinestra={true}>
                            <span className={styles.plataformaWrapper}>
                                <Imatge
                                    src='/_resources/logos/applestore.svg'
                                    layout='fill'
                                    objectFit='contain'
                                    alt={`Descarrega ${titol} a Apple App Store`}
                                />
                            </span>
                        </Enllac>
                    )}
                </div>
            </div>
        </div>
    );
}
